import ProviderPromotions from './components/ProviderPromotions.js';
import connect from './connect';

export default connect(ProviderPromotions);



// WEBPACK FOOTER //
// ./src/routes/ProviderPromotions/index.js